
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs",
      function () {
        return require("private-next-pages/faqs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faqs"])
      });
    }
  